module.exports = __webpack_public_path__ + "img/remision_1.12009b51.png";